<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <FormRow :fieldNameArr="[this.$t('GROUP_KEY')]">
        <Input v-model="groupId" slot="a" disabled />
      </FormRow>
      <Collapse :accordion="true">
        <Panel>
          {{ $t("LABEL_TEXT_BATCH_EDIT") }}
          <Form label-position="right" :label-width="120" :inline="true" slot="content">
            <FormItem :label="$t('COMMENTS')">
              <Icon type="ios-create" size="28" class="text-delta-blue" @click="showBatchCommentsModal" />
            </FormItem>
            <FormItem :label="$t('VALID_FROM')">
              <DatePicker
                type="date"
                format="yyyy-MM-dd"
                :placeholder="$t('VALID_FROM')"
                v-model="batchValidFrom"
              ></DatePicker>
            </FormItem>
            <FormItem :label="$t('VALID_TO')">
              <DatePicker
                type="date"
                format="yyyy-MM-dd"
                :placeholder="$t('VALID_TO')"
                v-model="batchValidTo"
              ></DatePicker>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="batchSave">{{ $t("BUTTON_TEXT_SAVE") }}</Button>
            </FormItem>
          </Form>
        </Panel>
      </Collapse>
      <FormRow v-if="supplierQuotationFilesExisted" :fieldNameArr="[$t('REFERENCE_FILE')]">
      </FormRow>
      <FormRow v-if="supplierQuotationFilesExisted" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="supplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <FormRow v-if="cpcToSupervisorAttachmentsExisted" :fieldNameArr="[$t('APPROVE') + ' ' + $t('REFERENCE_FILE')]">
      </FormRow>
      <FormRow v-if="cpcToSupervisorAttachmentsExisted" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToSupervisorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <br />
      <Table :columns="quotationColumnList" :data="quotationList">
        <template slot-scope="{ row, index }" slot="alert">
          <Icon type="ios-radio-button-on" size="28" :class="alertColorClass(row)" />
        </template>
        <template slot-scope="{ row, index }" slot="comments">
          <Icon type="ios-create" size="28" class="text-delta-blue" @click="showCommentsModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="historyComments">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showHistoryCommentsModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="newAndOld">
          <div>{{ row.currentPrice === undefined || row.currentPrice === null ? "NEW" : "OLD" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="infoRecord">
          <div v-if="row.infoRecordFlag">
            <span>YES</span>
            <Icon type="ios-create" size="28" class="text-delta-blue" @click="showInfoRecordMaintainModal(index, row.uuid)" />
          </div>
          <div v-else>
            <span>NO</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="highPrice">
          <div v-if="row.highPrice && row.quotationHighPrice">
            <Icon type="ios-warning" size="28" class="text-delta-red" />
            <span>{{ row.quotationHighPrice.priceDifference }}%</span>
            <br/>
            <span>{{ row.quotationHighPrice.orgCheck === 'C' ? 'Cross' : 'Single' }}</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="deltaPartAndDeltaPartDescription">
          <div>{{ row.partNo ? row.partNo : "" }}<br>{{ row.partDescription ? row.partDescription : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="itemCategory">
          <span v-if="quotationList[index].itemCategory === 'STANDARD'">Standard</span>
          <span v-if="quotationList[index].itemCategory === 'SUBCONTRACTION'">Subcontraction</span>
        </template>
        <template slot-scope="{ row, index }" slot="unitPriceAndCurrency">
          <div>{{ row.unitPrice ? row.unitPrice : "" }}/{{ row.currency ? row.currency : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="rfqCd">
          <div v-if="row.currentPrice">{{ Math.floor(((row.rfqQty * row.currentPrice - row.rfqQty * row.unitPrice) / (row.rfqQty * row.currentPrice) * 100) * 100) / 100 }}</div>
          <div v-else>NA</div>
        </template>
        <template slot-scope="{ row, index }" slot="targetCd">
          <div v-if="row.unitPrice">{{ Math.floor(((row.rfqQty * row.targetPrice - row.rfqQty * row.unitPrice) / (row.rfqQty * row.targetPrice) * 100) * 100) / 100 }}</div>
          <div v-else>NA</div>
        </template>
        <template slot-scope="{ row, index }" slot="validFromAndValidTo">
          <DatePicker v-model="quotationList[index].validFrom" type="date" format="yyyy-MM-dd" placeholder="Select Date"></DatePicker>
          <DatePicker v-model="quotationList[index].validTo" type="date" format="yyyy-MM-dd" placeholder="Select Date"></DatePicker>
        </template>
        <template slot-scope="{ row, index }" slot="scalePrice">
          <Icon :type="row.scalePrices && row.scalePrices.length > 0 ? 'md-reorder' : ''" size="28" class="text-delta-blue" @click="showScalePriceModal(index)" />
        </template>
      </Table>
      <Row v-if="quotationList.length > 0" type="flex" justify="space-between">
        <Col type="flex" justify="start">{{ $t("COMMON_TEXT_FROM") }} {{ pageObj.page * pageObj.pageSize - (pageObj.pageSize - 1) }}{{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObj.totalCount < pageObj.page * pageObj.pageSize">{{ pageObj.totalCount }}</span>
          <span v-else> {{ pageObj.page * pageObj.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObj.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page :total="pageObj.totalCount" :page-size="pageObj.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePage" @on-page-size-change="changePageSize" show-sizer :page-size-opts="[20, 50, 100]"></Page>
        </Col>
      </Row>
    </Feature>
    <ButtonRow>
      <Button type="primary" @click="save" slot="1">{{ $t("SAVE") }}</Button>
      <Button type="success" @click="approve" slot="2">{{ $t("APPROVE") }}</Button>
      <Button type="error" @click="reject" slot="3">{{ $t("REJECT") }}</Button>
      <Button type="primary" @click="Back" slot="4">{{ $t('BACK') }}</Button>
      <Button type="info" @click="Download" slot="5">{{ $t('DOWNLOAD') }}</Button>
    </ButtonRow>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="batchCommentsModal"
      :title="$t('COMMENTS')"
    >
      <froala :config="FloraEditorConfig" v-model="batchComments"></froala>
    </Modal>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModel"
      :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="9999" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="scalePricesModel"
      :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModel"
      :title="$t('COMMENTS')" @on-ok="confirmComments">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="remarkModel"
      :title="$t('REMARK')" @on-ok="confirmRemark">
      <froala :config="FloraEditorConfig" v-model="remark"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="referencePriceModel" :title="$t('REFERENCE_PRICE_DATA')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="referencePriceColumnList" :data="referencePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logCommentModel"
      :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="logComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="infoRecordMaintainModal" :title="$t('INFO_RECORD_MAINTAIN')">
      <InfoRecordMaintain v-if="infoRecordMaintainModal" :quotation="quotation" :materialTypeList="materialTypeList"></InfoRecordMaintain>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, FloraEditorConfig, DownloadFile } from "@/util/common"
import { AlertInfo, AlertError } from "@/util/alert"
import { FileSchemaList } from "@/util/tableTitle"
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"

export default {
  name: "SupervisorMaintain",
  props: {
    quotationStatus: {
      type: String
    }
  },
  components: {
    InfoRecordMaintain
  },
  inject: ["reload"],
  created() {
    const vueInstance = this
    if (vueInstance.groupId) {
      vueInstance.$quotationHttp
        .get("/supervisor/rfq/" + vueInstance.groupId + "/quotationFiles")
        .then(response => {
          if (response.data) {
            vueInstance.supplierQuotationFiles = response.data;
          }
        });
      vueInstance.$quotationHttp
        .get("/supervisor/rfq/" + vueInstance.groupId + "/approveFiles")
        .then(response => {
          if (response.data) {
            vueInstance.cpcToSupervisorAttachments = response.data;
          }
        });
      vueInstance.search(true);
    } else {
      vueInstance.Back()
    }
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      fileSchemaList: FileSchemaList(this),
      pageObj: {
        page: 0,
        totalPage: 0,
        totalCount: 0,
        pageSize: 20,
        sort: ["partNo,asc"],
      },
      batchCommentsModal: false,
      batchComments: "",
      batchValidFrom: "",
      batchValidTo: "",
      quotationUuid: '',
      logModel: false,
      scalePricesModel: false,
      commentsModel: false,
      remarkModel: false,
      referencePriceModel: false,
      flowCommentModel: false,
      cpcToSupervisorAttachments: [],
      logComment: '',
      logCommentModel: false,
      flowComment: '',
      quotationDocuments: [],
      quotationLogList: [],
      supplierQuotationFiles: [],
      scalePrices: [],
      comments: '',
      remark: '',
      excelQuotationList: [],
      metalAttributeModel: false,
      plasticAttributeModel: false,
      referencePrice: '',
      priceList: [],
      referencePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          key: "materialNumber",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('AGENT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "agent",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('AGENT_NAME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          key: "agentName",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('INFO_CATEGORY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "purchInfoRecordCategory",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "validFromDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "validToDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "unitPirce",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('USD_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "usdPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UOM');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "conditionUnit",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('%');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "percentage",
        },
      ],
      referencePrices: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      quotationLogColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ROLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quotationRole",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowStatus",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowAction",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "created",
          width: 180,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PERSON_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "personEmail",
          width: 200,
          align: "center",
        },
      ],
      quotationList: [],
      deltaPn: "",
      vendorCode: "",
      fromRfqDate: "",
      toRfqDate: "",
      status: "",
      quotation: {},
      infoRecordMaintainModal: false,
      materialTypeList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getSupervisorGroupUuid", "getSupervisorGroupId", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    showBatchCommentsModal() {
      this.batchCommentsModal = true
    },
    search(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.pageObj = {
          page: 0,
          totalPage: 0,
          totalCount: 0,
          pageSize: 20,
          sort: ["partNo,asc"],
        };
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .get("/supervisor/rfq/" + vueInstance.groupId + "/quotationDetails?page=" + vueInstance.pageObj.page + "&size=" + vueInstance.pageObj.pageSize + (vueInstance.pageObj.sort === undefined || Array.isArray(vueInstance.pageObj.sort) === false || vueInstance.pageObj.sort.length === 0 ? "" : "&sort=" + vueInstance.pageObj.sort.join("&sort=")))
        .then(response => {
          vueInstance.quotationList = [];
          vueInstance.quotationList = response.data.content;
          vueInstance.quotationList.forEach(quotation => {
            quotation.validFrom = quotation.validFrom === undefined || quotation.validFrom === null ? new Date() : new Date(quotation.validFrom);
            quotation.validTo = quotation.validTo === undefined || quotation.validTo === null ? vueInstance.defaultValidTo : new Date(quotation.validTo);
            vueInstance.pageObj = {
              page: response.data.number + 1,
              totalPage: response.data.totalPages,
              totalCount: response.data.totalElements,
              pageSize: response.data.size,
              sort: ["partNo,asc"],
            };
            if (vueInstance.quotationList.length === 0) {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => h("span", [Translate("COMMON_TEXT_NOTHING")]),
              });
            }
          });
        })
        .catch(() => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    changePageSize(newPageSize) {
      const vueInstance = this;
      vueInstance.pageObj.pageSize = newPageSize;
      vueInstance.pageObj.page = 0;
      vueInstance.search(false);
    },
    changePage(page) {
      const vueInstance = this;
      vueInstance.pageObj.page = page - 1;
      vueInstance.search(false);
    },
    batchSave() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/supervisor/rfq/batch/save", {
          groupId: vueInstance.groupId,
          comments: vueInstance.batchComments || null,
          validFrom: vueInstance.parseDate(vueInstance.batchValidFrom),
          validTo: vueInstance.parseDate(vueInstance.batchValidTo)
        })
        .then(response => {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: vueInstance.$t("COMMON_MESSAGE_SUCCESS"),
            })
            .then(() => {
              vueInstance.reload();
            });
        })
        .catch(error => {
          console.error(error);
          vueInstance.$Swal.fire({
            icon: "error",
            title: vueInstance.$t("COMMON_MESSAGE_ERROR"),
            text: vueInstance.$buildErrorMessage(error),
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    save() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/supervisor/rfq/save", {
          quotationRequestList: vueInstance.quotationList.map(quotation => {
            return {
              formNo: quotation.formNo,
              comments: quotation.comments,
              validFrom: vueInstance.parseDate(quotation.validFrom),
              validTo: vueInstance.parseDate(quotation.validTo)
            };
          })
        })
        .then(response => {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: vueInstance.$t("COMMON_MESSAGE_SUCCESS")
          });
        })
        .catch(error => {
          console.error(error);
          vueInstance.$Swal.fire({
            icon: "error",
            title: vueInstance.$t("COMMON_MESSAGE_ERROR"),
            text: vueInstance.$buildErrorMessage(error)
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    approve() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/supervisor/rfq/approve", {
          groupId: vueInstance.groupId
        })
        .then(response => {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: response.data.content[0].status
          })
          .then(() => {
            vueInstance.$router.push({
              name: "SUPERVISOR_MAINTAIN"
            });
          });
        })
        .catch(error => {
          console.error(error);
          vueInstance.$Swal.fire({
            icon: "error",
            title: vueInstance.$t("COMMON_MESSAGE_ERROR"),
            text: vueInstance.$buildErrorMessage(error)
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    reject() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/supervisor/rfq/reject", {
          groupId: vueInstance.groupId
        })
        .then(response => {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: response.data.content[0].status
          })
          .then(() => {
            vueInstance.$router.push({
              name: "SUPERVISOR_MAINTAIN"
            });
          });
        })
        .catch(error => {
          console.error(error);
          vueInstance.$Swal.fire({
            icon: "error",
            title: vueInstance.$t("COMMON_MESSAGE_ERROR"),
            text: vueInstance.$buildErrorMessage(error)
          });
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    confirmComments() {
      const vueInstance = this
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid == vueInstance.quotationUuid) {
          temp.comments = vueInstance.comments
        }
      })
    },
    confirmRemark() {
      this.quotationList.forEach(temp => {
        if (temp.id == this.quotationUuid) {
          temp.remark = this.remark
        }
      })
    },
    Back() {
      this.$router.push({ name: 'SUPERVISOR_MAINTAIN' })
    },
    Download() {
      let vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .get("/rfq/download/" + vueInstance.getSupervisorGroupUuid(), { responseType: 'blob' })
        .then((response) => {
          vueInstance.toggleLoading(false)
          if (response.data) {
            DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
          }
        })
        .catch((error) => {
          if (error.response.status == 444) {
            let text = "records to many, please fill in criteria or give a start and size of records."
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
    },
    parseDate(date) {
      if (!(date instanceof Date) || isNaN(date)) {
        return null
      }

      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date
          .getDate()
          .toString()
          .padStart(2, "0")
      )
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    showCommentsModal(index, uuid) {
      this.comments = this.quotationList[index].comments ?? "";
      this.actionType = this.quotationList[index].action ?? "";
      this.quotationUuid = uuid;
      this.commentsModel = true;
    },
    showHistoryCommentsModal(index, uuid) {
      this.toggleLoading(true);
      this.$queryQuotationLog(this, uuid)
        .then(data => {
          this.quotationUuid = uuid;
          this.logComment = "";
          data.forEach(log => {
            if (log.quotationRole) {
              this.logComment = this.logComment + this.$t("ROLE") + ": " + log.quotationRole + ", ";
            }
            if (log.quotationRole) {
              this.logComment = this.logComment + this.$t("STATUS") + ": " + log.flowStatus + ", ";
            }
            if (log.groupAccount) {
              this.logComment = this.logComment + this.$t("GROUP_ACCOUNT") + ": " + log.groupAccount.code + "/" + log.groupAccount.companyName + ", ";
            }
            if (log.created) {
              this.logComment = this.logComment + this.$t("CREATE_DATE") + ": " + log.created + ": <br>";
            }
            if (log.flowComment) {
              this.logComment = this.logComment + log.flowComment;
            }
            this.logComment = this.logComment + "<hr style=\"border:1px dashed #000; height:1px\">";
          });
          this.logCommentModel = true;
        })
        .catch(error => {
          AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => {});
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    showInfoRecordMaintainModal(index, uuid) {
      this.quotation = this.quotationList[index].quotationDetailInfoRecordDto;
      this.infoRecordMaintainModal = true;
    },
    showScalePriceModal(index) {
      this.scalePrices = this.quotationList[index].scalePrices;
      this.scalePricesModel = true;
    },
    alertColorClass(row) {
      if (row.targetPrice !== row.unitPrice) {
        return "text-delta-yellow";
      }
      if (row.currentPrice === undefined || row.currentPrice === null || row.unitPrice === row.currentPrice) {
        return "text-delta-blue";
      }
      if (row.unitPrice > row.currentPrice) {
        return "text-delta-red";
      }
      return "text-delta-green";
    }
  },
  computed: {
    groupId: {
      get() {
        return this.getSupervisorGroupId();
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    supplierQuotationFilesExisted() {
      return this.supplierQuotationFiles && this.supplierQuotationFiles.filter(attachment => !attachment.deleted).length > 0
    },
    cpcToSupervisorAttachmentsExisted() {
      return this.cpcToSupervisorAttachments && this.cpcToSupervisorAttachments.filter(attachment => !attachment.deleted).length > 0
    },
    quotationColumnList() {
      return [{
        title: this.$t("ALERT"),
        align: "center",
        width: 50,
        slot: "alert"
      }, {
        title: this.$t("COMMENTS"),
        align: "center",
        width: 70,
        slot: "comments"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("HISTORY"), 
            h("br"), 
            this.$t("COMMENTS")
          ]);
        },
        align: "center",
        width: 70,
        slot: "historyComments"
      }, {
        title: this.$t("NEW_AND_OLD"),
        align: "center",
        width: 60,
        slot: "newAndOld"
      }, {
        title: this.$t("INFO_RECORD"),
        align: "center",
        width: 60,
        slot: "infoRecord",
      }, {
        title: this.$t("HIGH_PRICE"),
        align: "center",
        width: 60,
        slot: "highPrice"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("DELTA_PN"), 
            h("br"), 
            this.$t("PN_DESCRIPTION")
          ]);
        },
        align: "center",
        width: 100,
        slot: "deltaPartAndDeltaPartDescription"
      }, {
        title: this.$t("VENDOR_PN"),
        align: "center",
        width: 80,
        key: "vendorPartNo"
      }, {
        title: this.$t("RFQ_QUANTITY"),
        align: "center",
        width: 60,
        key: "rfqQty"
      }, {
        title: this.$t("ITEM_CATEGORY"),
        align: "center",
        width: 100,
        slot: "itemCategory"
      }, {
        title: this.$t("PLANT_CODE"),
        align: "center",
        width: 50,
        key: "plant"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("TARGET"), 
            h("br"), 
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 60,
        key: "targetPrice"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("CURRENT"), 
            h("br"), 
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 60,
        key: "currentPrice"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("UNIT_PRICE"), 
            h("br"), 
            this.$t("CURRENCY")
          ]);
        },
        align: "center",
        width: 90,
        slot: "unitPriceAndCurrency"
      }, {
        title: "RFQ CD%",
        align: "center",
        width: 90,
        slot: "rfqCd"
      }, {
        title: "Target CD%",
        align: "center",
        width: 90,
        slot: "targetCd"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("VALID_FROM"), 
            h("br"), 
            this.$t("VALID_TO")
          ]);
        },
        align: "center",
        width: 140,
        slot: "validFromAndValidTo"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("SCALE"), 
            h("br"), 
            this.$t("PRICE")
          ]);
        },
        align: "center",
        width: 60,
        slot: "scalePrice"
      }];
    }
  }
}
</script>
  
<style scoped></style>
  